module.exports = __webpack_public_path__ + "img/facebook.59dc5bc3.svg";